export const MIDDLEWARE = "/edge/dashboard/middleware";
export const ENDPOINTS = {
  todo : "/todos/1",
  getHeader: "/edge-header/edge/header",
  getCount: "/dashapi/post/job/htnct",
  getChatCount: "/chat-module-service/api/v1/chat/unread/count",
  chatServiceCheck: "/recruiter4chat/service/check",
  getRecentSearches:`/edge/recruiter/v4/recruiter-srp/api/v1/recentSearches`,
}